module.exports = __webpack_public_path__ + "img/banner-imgMob2x.png";